<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expandContent="{ row }">
        <BatchBoxTable
          :disabled="disabled"
          :shipmentCode="row.shipmentCode"
          :shipmentBatchCode="row.shipmentBatchCode"
          @reload="$emit('reload')"
          class="m-2"
        />
      </template>

      <template v-slot:batchAmount="{ row }">
        <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span
          >{{ row.v_batchSalePriceAmount || 0 }}
          {{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import BatchBoxTable from '../batch-box-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  components: { BatchBoxTable },
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    sourceType: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible || c.visible === undefined)
        .map((t) => totalColumnValues[t.field] || '')
      result[0] = '合计'

      return [result]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    del({ shipmentCode, shipmentBatchCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentBatchDelApi({
            shipmentCode,
            shipmentBatchCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
